import React from 'react';

const CardListPlusButton = () => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 29 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Card List Plus Button</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="Credit-cards-on-file"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-632.000000, -358.000000)"
    >
      <g id="Group-19" transform="translate(529.000000, 140.000000)">
        <g id="Plus" transform="translate(103.000000, 218.000000)">
          <circle id="Oval-3" fill="#52CAB8" cx="14.5" cy="14.5" r="14.5" />
          <g
            id="Group-21"
            transform="translate(5.000000, 5.000000)"
            stroke="#F7F7F7"
            strokeLinecap="square"
            strokeWidth="3"
          >
            <path d="M9.5,0.5 L9.5,18.5" id="Line-3" />
            <path d="M0.5,9.5 L18.5,9.5" id="Line-4" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CardListPlusButton;



// WEBPACK FOOTER //
// ./src/assets/CardListPlusButton.jsx